import { NotificationDefinition } from '../../types'
import { QuoteAutoExecuteFailedHeader } from './QuoteAutoExecuteFailedHeader'
import { QuoteAutoExecuteFailedListItem } from './QuoteAutoExecuteFailedListItem'
import { QuoteAutoExecuteFailedPreview } from './QuoteAutoExecuteFailedPreview'

export const quoteAutoExecuteFailedDefinition: NotificationDefinition = {
  listItemContent: QuoteAutoExecuteFailedListItem,
  previewHeaderContent: QuoteAutoExecuteFailedHeader,
  previewContent: QuoteAutoExecuteFailedPreview
}
